import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectClientLabelEditable = (store: StoreSchema) =>
	store.clientLabel.clientLabelEditable